import React from 'react';
import { MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer id="legal" className="bg-navy text-white pt-20 pb-10" data-id="element-197">
      <div className="container mx-auto max-w-[var(--maxw)] px-4 sm:px-6" data-id="element-198">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 mb-12 sm:mb-16" data-id="element-199">
          {/* Column 1: Company Info */}
          <div className="space-y-6" data-id="element-200">
            <img src="https://cdn.magicpatterns.com/uploads/9Pc1EdXJ5Kiaov2hDznTrF/CIA_Logo_latest.png" alt="COSMO IMAGE AVIATION" className="h-12 brightness-0 invert" data-id="element-201" />
            <div className="space-y-2 text-gray-400 text-sm" data-id="element-202">
              <p className="font-semibold text-white" data-id="element-203">
                COSMO IMAGE AVIATION PTE. LTD.
              </p>
              <p data-id="element-204">Company Reg No: 202312119R</p>
              <div className="pt-4 mt-4 border-t border-white/10" data-id="element-205">
                <p className="text-xs text-gray-500" data-id="element-206">
                  Content verified against ACRA records (March 2025).
                </p>
              </div>
            </div>
          </div>

          {/* Column 2: Services */}
          <div data-id="element-207">
            <h3 className="text-sm font-bold mb-6 uppercase tracking-wider text-white" data-id="element-208">
              Our Services
            </h3>
            <ul className="space-y-3 text-gray-400 text-sm" data-id="element-209">
              <li data-id="element-210">
                <a href="/#services" className="hover:text-white transition-colors" data-id="element-211">
                  Aircraft Management
                </a>
              </li>
              <li data-id="element-212">
                <a href="/#services" className="hover:text-white transition-colors" data-id="element-213">
                  CAMO Services
                </a>
              </li>
              <li data-id="element-214">
                <a href="/#services" className="hover:text-white transition-colors" data-id="element-215">
                  Aircraft Charter
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3: Quick Links */}
          <div data-id="element-216">
            <h3 className="text-sm font-bold mb-6 uppercase tracking-wider text-white" data-id="element-217">
              Quick Links
            </h3>
            <ul className="space-y-3 text-gray-400 text-sm" data-id="element-218">
              <li data-id="element-219">
                <a href="/#home" className="hover:text-white transition-colors" data-id="element-220">
                  Home
                </a>
              </li>
              <li data-id="element-221">
                <a href="/#about" className="hover:text-white transition-colors" data-id="element-222">
                  About Us
                </a>
              </li>
              <li data-id="element-223">
                <a href="/#services" className="hover:text-white transition-colors" data-id="element-224">
                  Services
                </a>
              </li>
              <li data-id="element-225">
                <a href="/#fleet" className="hover:text-white transition-colors" data-id="element-226">
                  Fleet Access
                </a>
              </li>
              <li data-id="element-227">
                <a href="/#leadership" className="hover:text-white transition-colors" data-id="element-228">
                  Leadership
                </a>
              </li>
              <li data-id="element-229">
                <a href="/#contact" className="hover:text-white transition-colors" data-id="element-230">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact */}
          <div data-id="element-231">
            <h3 className="text-sm font-bold mb-6 uppercase tracking-wider text-white" data-id="element-232">
              Contact Us
            </h3>
            <ul className="space-y-4 text-gray-400 text-sm" data-id="element-233">
              <li className="flex items-start gap-3" data-id="element-234">
                <MapPinIcon className="w-5 h-5 text-white/70 flex-shrink-0 mt-0.5" data-id="element-235" />
                <span data-id="element-236">
                  1 Liang Seah Street, #02-02
                  <br data-id="element-237" />
                  Singapore 189022
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-238">
                <PhoneIcon className="w-5 h-5 text-white/70 flex-shrink-0" data-id="element-239" />
                <a href="tel:+6581266622" className="hover:text-white transition-colors" data-id="element-240">
                  +65 8126 6622
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-241">
                <MailIcon className="w-5 h-5 text-white/70 flex-shrink-0" data-id="element-242" />
                <a href="mailto:contact@cosmoimageaviation.co" className="hover:text-white transition-colors break-all" data-id="element-243">
                  contact@cosmoimageaviation.co
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Legal Accordions */}
        <div className="border-t border-white/10 pt-8 pb-8 mb-8" data-id="element-244">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-245">
            <details className="group" data-id="element-246">
              <summary className="cursor-pointer font-medium text-sm text-gray-300 hover:text-white transition-colors list-none flex items-center justify-between border-b border-white/10 pb-2" data-id="element-247">
                <span data-id="element-248">Privacy Policy</span>
                <span className="text-gray-500 group-open:rotate-180 transition-transform" data-id="element-249">
                  ↓
                </span>
              </summary>
              <div className="pt-4 text-xs text-gray-500 space-y-3" data-id="element-250">
                <p data-id="element-251">
                  COSMO IMAGE AVIATION PTE. LTD. is committed to protecting your
                  privacy. This Privacy Policy explains how we collect, use, and
                  safeguard your information when you visit our website or
                  contact us.
                </p>
                <p data-id="element-252">
                  We collect personal information that you voluntarily provide
                  to us when you contact us through our website. We use this
                  information solely for the purpose of responding to your
                  inquiries and providing our services.
                </p>
                <p data-id="element-253">
                  We do not sell, trade, or otherwise transfer your personally
                  identifiable information to outside parties except as
                  necessary to provide our services or as required by law.
                </p>
              </div>
            </details>

            <details className="group" data-id="element-254">
              <summary className="cursor-pointer font-medium text-sm text-gray-300 hover:text-white transition-colors list-none flex items-center justify-between border-b border-white/10 pb-2" data-id="element-255">
                <span data-id="element-256">Terms of Use</span>
                <span className="text-gray-500 group-open:rotate-180 transition-transform" data-id="element-257">
                  ↓
                </span>
              </summary>
              <div className="pt-4 text-xs text-gray-500 space-y-3" data-id="element-258">
                <p data-id="element-259">
                  By accessing this website, you agree to be bound by these
                  Terms of Use, all applicable laws and regulations, and agree
                  that you are responsible for compliance with any applicable
                  local laws.
                </p>
                <p data-id="element-260">
                  All content on this website is the property of COSMO IMAGE
                  AVIATION PTE. LTD. and is protected by copyright and other
                  intellectual property laws.
                </p>
                <p data-id="element-261">
                  We reserve the right to modify or discontinue any aspect of
                  this website at any time without notice.
                </p>
              </div>
            </details>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center text-xs text-gray-500" data-id="element-262">
          <p data-id="element-263">© 2025 COSMO IMAGE AVIATION PTE. LTD. All Rights Reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-264">
            <a href="#" className="hover:text-white transition-colors" data-id="element-265">
              Privacy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-266">
              Cookies
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-267">
              Legal
            </a>
          </div>
        </div>
      </div>
    </footer>;
}